import Cookies from 'js-cookie'
import { Events } from '../events/events.js';
export class User {

  empty_user = {
    id: 0,
    logged: false,
    email: "",
    firstname: "",
    lastname: "",
    promo_team: 0,
    promo_team_changed: 0,
    status: 0,
    roles: 0,
    session_hash: 0,
    isocode: {
      country_num: 32,
      country: 'AR',
      continent: 'SA'
    },
    ui_code: 'AR',
    screen_currency: 'ARS',
    fromStorage: true
  };

  integer_fields = [
    'id',
    'promo_team',
    'promo_team_changed',
    'status',
    'roles',
    'allow_commercial_emails',
    'country',
    'logged',
    'password_changed',
    'play_token'
  ];


  current_user = this.empty_user;

  constructor(brandId, _this) {
    this.self = _this;
    this.brandId = brandId;

    // Miramos si hay sesión guardada
    let lastUserData = localStorage.getItem(brandId + "lastUserData");

    // Si no tenemos datos de usuario, ponemos los datos por defecto
    if (lastUserData) {
      try {
        this.current_user = JSON.parse(lastUserData);
        this.current_user.fromStorage = true;
        // Disparamos el evento de usuario
        this.self.emit(Events.USER_AVAILABLE, this.current_user);
      } catch (error) {
        console.error('[User] Error parsing lastUserData: ', error.message);
      }
    }

  }

  /**
   * Devuelve el usuario actual consultando el servidor si es necesario
   *
   * @memberof User
   */
  async getUser(options = { force: false }) {

    if (!options.force && this.current_user) {
      return this.current_user;
    }

    let data = null;

    try {
      data = await this.self.api.call('init', null);
    } catch (error) {
      console.error('[User] Error: ', error.message);

      // Devolvemos el usuario que tengamos en memoria
      return this.current_user;
    }

    // Si data es null, devolvemos el usuario que tengamos en memoria
    if (!data) {
      // Si no tenemos current_user, lanzamos error
      if (!this.current_user) {
        console.error("[User] Unable to retrieve user");
        return;
      }
      return this.current_user;
    }

    data.user.fromStorage = false;

    //Si no nos viene geolocalización, ponemos Argentina por defecto
    if (data && data.user.isocode == '') {
      data.user.isocode = new Object();
      data.user.isocode.country_num = 32;
      data.user.isocode.country = 'AR';
      data.user.isocode.continent = 'SA';
    }

    // Pasamos a entero todos los campos que sean int
    data.user = this.self.parseIntegerFields(data.user, this.integer_fields);

    // Pasamos a número los roles
    if (data.user.roles_list) {
      data.user.roles_list = data.user.roles_list.map(function (r) {
        return parseInt(r);
      });
    }

    this.current_user = data.user;

    // Guardamos los datos en localstorage
    localStorage.setItem(this.brandId + "lastUserData", JSON.stringify(data.user));

    // Disparamos el evento de usuario
    this.self.emit(Events.USER_UPDATE, data.user);

    return data.user;

  }

  async refresh() {
    return this.getUser({ force: true });
  }

  setSession(user_id, session_hash) {
    this.current_user.id = user_id;
    this.current_user.session_hash = session_hash;
  }

  /**
   * Loguea al usuario
   *
   * @param {*} user Usuario
   * @param {*} pass Contraseña
   * @param {*} [onDone=null] Función a ejecutar al terminar
   * @param {*} [onError=null] Función a ejecutar en caso de error
   */
  async login(user, pass) {

    return this.self.api.call('login', {
      email: user,
      password: pass
    }).then(data => {

      // Guardamos los datos en localstorage
      localStorage.setItem(this.brandId + "lastUserData", JSON.stringify(data.user));

      this.current_user = data.user;

      // Disparamos el evento de usuario
      this.self.emit(Events.USER_UPDATE, data.user);

      return data.user;
    });
  }


  isAdmin() {
    return user.is_admin ? true : false;
  }


  /**
   * Cierra la sesión del usuario
   *
   */
  async logout() {

    // Llamamos a la API para cerrar sesión
    return this.self.api.call('logout').then(data => {

      // Guardamos los datos del empty user porque incluye geolocalización
      localStorage.setItem(this.brandId + "lastUserData", JSON.stringify(data.user));
      this.current_user = data.user;

      // Disparamos el evento de usuario
      this.self.emit(Events.USER_UPDATE, data.user);

      return data.user;

    });
  }

  /**
   * Comprueba si el usuario tiene un rol
   *
   * @param int role Rol a comprobar
   * @return boolean
   * @memberof User
   */
  hasRole(role) {
    if (!this.current_user.roles_list) {
      return false;
    }

    // Lo pasamos a número
    role = parseInt(role);
    return this.current_user.roles_list.includes(role);
  }

  /**
  * Comprueba si el usuario tiene un feature de producto
  *
  * @param int ID de producto
  * @param int ID de feature
  * @return boolean
  * @memberof User
  */
  hasProductFeature(productID, featureID) {

    // Si no hay features, devolvemos false
    if (!this.current_user.purchased_features) {
      return false;
    }

    // Pasamos a número
    productID = parseInt(productID);
    featureID = parseInt(featureID);

    // Recorremos los productos comprados
    for (let product of this.current_user.purchased_features) {

      // Pasamos a número
      product.product_id = parseInt(product.product_id);

      // Recorremos los features de cada producto
      for (let feature of product.features) {
        // Si el feature coincide, devolvemos true
        if (feature == featureID && product.product_id == productID) {
          return true;
        }
      }
    }

    // No lo hemos encontrado
    return false;

  }

  /**
   * Devuelve la lista de suscripciones activas
   *
   * @return 
   * @memberof User
   */
  activeSuscriptions() {
    let active = [];

    // Si no tenemos purchased_features, devolvemos vacío
    if (!this.current_user.purchases) {
      return active;
    }

    // Recorremos las entradas
    for (let purchase of this.current_user.purchases) {

      if (parseInt(purchase.status) != 1) {
        continue;
      }

      // Si es una suscripción
      if (parseInt(purchase.subscription)) {
        active.push(purchase);
      }
    }

    return active;
  }

  /**
   * Devuelve la lista de suscripciones activas
   *
   * @return 
   * @memberof User
   */
  activePurchases() {
    let active = [];

    // Si no tenemos purchased_features, devolvemos vacío
    if (!this.current_user.purchases) {
      return active;
    }

    // Recorremos las entradas
    for (let purchase of this.current_user.purchases) {

      if (parseInt(purchase.status) != 1) {
        continue;
      }

      // timestamp en segundos
      const now = new Date() / 1000;

      // Si ha expirado saltamos
      if (purchase.expires < now) {
        continue;
      }

      // Si es un pago
      if (!parseInt(purchase.subscription)) {
        active.push(purchase);
      }
    }

    return active;
  }


  /**
   * Setea el equipo favorito del usuario
   *
   * @param int team 
   * @return 
   * @memberof User
   */
  async setFavoriteTeam(team) {
    return this.self.api.call('team_change', {
      promo_team: parseInt(team)
    }).then(data => {
      this.current_user.promo_team = data.promo_team;
      return data.promo_team_object;
    });
  }

  /**
   * Setea el nombre del usuario
   *
   * @param string firstname
   * @param string lastname
   * @return 
   * @memberof User
   */
  async setName(firstname, lastname) {
    return this.self.api.call('name_change', {
      firstname: firstname,
      lastname: lastname
    }).then(data => {
      this.current_user.firstname = firstname;
      this.current_user.lastname = lastname;
      return this.current_user;
    });
  }

  /**
   * Setea el email del usuario
   *
   * @param string email
   * @return 
   * @memberof User
   */
  async setEmail(email) {
    return this.self.api.call('email_change', {
      email: email
    }).then(data => {
      this.current_user.email = email;
      return this.current_user;
    });
  }

  /**
   * Setea la contraseña del usuario
   *
   * @param string password
   * @return 
   * @memberof User
   */
  async setPassword(password) {
    return this.self.api.call('password_change', {
      password: password
    }).then(data => {
      // Se actualiza la info de usuario
      this.current_user = data;

      // Guardamos los datos en localstorage
      localStorage.setItem(this.brandId + "lastUserData", JSON.stringify(data));

      return data;
    });
  }

  /**
   * Recupera la contraseña del usuario
   * 
   * @param string email
   * @return int Número de error
   * @memberof User
   */
  async passwordRecovery(email) {
    return this.self.api.call('password_recovery', {
      email: email
    }).then(data => {
      return data;
    });
  }

  /**
   * Comprueba el token de verificación de email
   *
   * @param string token
   * @return 'ok' si es correcto o número de error
   * @memberof User
   */
  async verifyEmailToken(token) {
    return this.self.api.call('email_verify', {
      code: token
    }).then(data => {
      return data;
    });
  }

  /**
   * Reenvía el email de verificación si ha pasado más de 24h	
   *
   * @return 'ok' si se ha enviado correctamente o número de error
   * @memberof User
   */
  async verifyEmailTokenResend() {
    return this.self.api.call('email_verify_resend').then(data => {
      return data;
    });
  }

  /**
   * Crea un usuario
   *
   * @param {*} Objeto con email, password, firstname, lastname, promo_team y allow_commercial_emails
   * @return {*} Objeto usuario creado o número de error
   * @memberof User
   */
  async createUser(user) {
    return this.self.api.call('user_create', user).then(data => {

      // Si se ha creado correctamente, guardamos los datos en localstorage
      if (data.id) {
        localStorage.setItem(this.brandId + "lastUserData", JSON.stringify(data));
        this.current_user = data;
      }

      return data;
    });
  }

  /**
   * Elimina la cuenta del usuario
   * 
   * @param string email
   * @param string password
   * @return Usuario vacio o número de error
   * @memberof User
   */
  async deleteAccount(email, password) {
    return this.self.api.call('user_delete', {
      email: email,
      password: password
    }).then(data => {

      // Si se ha eliminado correctamente, guardamos los datos en localstorage
      if (typeof data.id != 'undefined') {
        localStorage.setItem(this.brandId + "lastUserData", JSON.stringify(data));
        this.current_user = data;
      }

      return data;
    });

  }

  /**
   * Hace check de login remoto
   *
   * @param string code
   * @return Usuario o número de error
   * @memberof User
   */
  async remoteLoginCheck(code) {
    return this.self.api.call('user_remote_login_check', {
      code: code
    }).then(data => {

      // Si se ha logueado correctamente, guardamos los datos en localstorage
      if (data.id) {
        localStorage.setItem(this.brandId + "lastUserData", JSON.stringify(data));
        this.current_user = data;
      }

      return data;
    });
  }

  /**
   * Crea el código de login remoto
   *
   * @param code
   * @return Código de login o número de error
   * @memberof User
   */
  async remoteLoginCreate(code) {
    return this.self.api.call('user_remote_login_create', {
      code: code
    }).then(data => {
      return data;
    });
  }

  /**
   * Intenta loguear al usuario con un token
   *
   * @param string token
   * @return Usuario o número de error
   * @memberof User
   */
  async tokenLogin(token) {
    return this.self.api.call('token_login', {
      token: token
    }).then(data => {

      // Si se ha logueado correctamente, guardamos los datos en localstorage
      if (data.user) {
        localStorage.setItem(this.brandId + "lastUserData", JSON.stringify(data.user));

        this.current_user = data.user;

        // Disparamos el evento de usuario
        this.self.emit(Events.USER_UPDATE, data.user);

      }

      return data.user;
    });
  }

  /**
   * Cambia el plan de producto del usuario
   *
   * @param {*} product_id 
   * @param {*} price_id 
   * @return 
   * @memberof User
   */
  async changePlan(product_id, price_id) {
    return this.self.api.call('change_plan', {
      product_id: product_id,
      price_id: price_id
    }).then(data => {

      // Si devuelve vacío, es que ha habido un error
      if (!data || !data.id) {
        return data;
      }

      // Nos devuelve el usuario actualizado
      this.current_user = data;

      // Guardamos los datos en localstorage
      localStorage.setItem(this.brandId + "lastUserData", JSON.stringify(data));

      // Disparamos el evento de usuario
      this.self.emit(Events.USER_UPDATE, data);

      return data;
    });
  }

}



